<script>
export default {
  data() {
    return {
      handleDown: false,
      mouseDownX: 0,
    };
  },

  mounted() {
    document.addEventListener('mouseup', this.mouseUp);
    document.addEventListener('mousemove', this.mouseMove);
  },

  beforeDestroy() {
    document.removeEventListener('mouseup', this.mouseUp);
    document.removeEventListener('mousemove', this.mouseMove);
  },

  methods: {
    mouseDown(e) {
      this.mouseDownX = e.x;
      this.handleDown = true;
    },

    mouseUp() {
      this.mouseDownX = 0;
      this.handleDown = false;
    },

    mouseMove(e) {
      if (this.handleDown) {
        // https://bugs.chromium.org/p/chromium/issues/detail?id=721341
        // there's is a bug in chrome which mouse move is triggered on
        // mouse down. fix it by saving last mouse down x and compare it
        // to mouse move x
        if (this.mouseDownX !== e.x) {
          this.onMouseMove && this.onMouseMove(e);
        }
      }
    },
  },
};
</script>
